import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import {
  getting_successful,
  message_notification,
  end_to_end_chat_loading,
  end_to_end_chat,
  getNotification,
  getChatInformation,
  notification_success,
  socketio,
  onlineUsers,
  SidebarOpen,
} from "../../Redux/ActionCreator";
const { io } = require("socket.io-client");
import { baseURL, employerUrl, baseURL1 } from "../../Redux/baseURL";
import { getOneFromServerCache, deleteAKey } from "../../utils/saveIntoCache";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import MoreMenu from "./MoreMenu";

const BottonBar = (props) => {
  const dispatch = useDispatch();
  const profile_stat = useSelector((prev) => prev.login);
  const chat_info = useSelector((e) => e.chat_info.message);
  const EmployeeProfile = useSelector((e) => e.profile);
  const body = EmployeeProfile.message;
  const Type = profile_stat.profile_status.AcctType;
  const [profile, setProfile] = useState(null);
  const msg_notification = useSelector((e) => e.msg_notification);
  const userInfo = useSelector((e) => e.userInfo.user);
  let Acct_profile =
    profile_stat.profile_status.AcctType === "Client"
      ? useSelector((e) => e.profile)
      : useSelector((prev) => prev.employer);
  const online = useSelector((e) => e.online.message);

  const notify = useSelector((e) => e.notification);
  let notification_list = notify.message;

  // const [ socket, setSocket ] = useState(null);
  const socket = useSelector((e) => e.socket?.message);
  const [onlineUser, setOnlineUser] = useState([]);
  const newMessage = useSelector((e) => e.end_to_end.message);
  const [newMsg, setNewMsg] = useState(newMessage?.message);
  const [notification, setNotification] = useState(0);
  const index = new URLSearchParams(window.location.search).get("i");
  const login_stat = useSelector((e) => e.login);
  const AcctType = login_stat?.profile_status?.AcctType;
  const apply = useSelector((e) => e.apply);
  const sidebar = useSelector((e) => e.sidebarOpen.message);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const getJobOwnerId = async () => {
    try {
      let response = await getOneFromServerCache("JobOwnerId");
      // // console.log("response", response);
      let resparse = await response.json();
      // // console.log("resparse", resparse);
      let data = JSON.parse(resparse.data);
      // // console.log("data", data);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const handleNoResume = () => {
    setTimeout(() => {
      toast.error("You don't have a resume yet. Kindly generate a resume ", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }, 50);
  };

  const jobId = window.location.pathname.split("/")[2];

  // useEffect(() => {
  //   dispatch(end_to_end_chat_loading(true));
  //   if (AcctType === "Official") {
  //     if (index !== null) {
  //       dispatch(getEndToEndChatInformation(chat_info[index]?.chatIds[0]?.employerId, chat_info[index]?.chatIds[0]?.employeeId?._id));

  //     dispatch(getting_successful([chat_info[index]?.chatIds[0]?.resumeId]));
  //     }
  //   }
  // }, [index]);

  useEffect(() => {
    if (
      profile_stat?.profile_status?.profile_status === "false" ||
      profile_stat?.profile_status?.profile_status === false
    ) {
      setProfile(false);
    } else if (
      profile_stat?.profile_status?.profile_status === "true" ||
      profile_stat?.profile_status?.profile_status === true
    ) {
      setProfile(true);
    }
  }, [profile_stat?.profile_status]);

  useEffect(() => {
    if (online !== null && Acct_profile.message !== null) {
      if (socket == null || socket.connected == false) {
        const newSocket = io(baseURL, {
          path: "/chat",
          withCredentials: true,
          cors: {
            origin: [employerUrl, baseURL1], // "http://localhost:3000", 'http://localhost:3001'
          },
        });
        // socketClient.connect();
        // setSocket(newSocket);
        dispatch(socketio(newSocket));
        // // console.log("socket", socket);
      } else if (socket !== null && socket.connected == true) {
        let checkIfIAmOnline = online.filter(
          (e) => e.userId === Acct_profile.message?._id
        );
        // // console.log("checkIfIAmOnline", checkIfIAmOnline);
        if (checkIfIAmOnline.length === 0) {
          socket?.emit("addUser", Acct_profile.message?._id);
          socket?.on("onlineUser", (resp) => {
            // setOnlineUser(resp);
            dispatch(onlineUsers(resp));
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    // if (index === null) {
    const newSocket = io(baseURL, {
      path: "/chat",
      withCredentials: true,
      cors: {
        origin: [employerUrl, baseURL1], // "http://localhost:3000", 'http://localhost:3001'
      },
    });
    // socketClient.connect();
    // setSocket(newSocket);
    dispatch(socketio(newSocket));

    return () => {
      newSocket.disconnect();
    };
    // }
  }, [Acct_profile]);
  // console.log("Online users", online);
  useEffect(() => {
    // if (index === null) {
    if (socket === null) return;
    // console.log("Acct_profile.message?._id", Acct_profile.message?._id)
    socket.emit("addUser", Acct_profile.message?._id);
    socket.on("onlineUser", (resp) => {
      // setOnlineUser(resp);
      dispatch(onlineUsers(resp));
    });
    // }
  }, [socket]);

  useEffect(() => {
    if (newMessage !== null && newMessage !== undefined) {
      if (AcctType === "Official") {
        if (chat_info !== null) {
          if (chat_info[index]?._id !== newMessage?.chatId) {
            return;
          }
          dispatch(end_to_end_chat(newMessage?.message));
        }
      }
    }
  }, [newMessage]);

  // useEffect(() => {
  //   if (socket === null) return;

  //   if (newMessage?.message !== undefined) {
  //     if (AcctType === "Official") {
  //       if (chat_info !== null) {
  //         socket.emit("sendMessage", { ...newMessage, otherId: chat_info[index]?.chatIds[0]?.employeeId?._id, AcctType: AcctType, name: Acct_profile.message?.name  });
  //         if (newMessage?.message !== null) {
  //
  //         }
  //       }
  //     }
  //   }
  // }, [newMessage]);

  useEffect(() => {
    if (socket === null) return;
    socket.on("jobNotification", (resp) => {
      // console.log("listening", resp)
      if (notification_list !== null && notification_list !== undefined) {
        dispatch(notification_success([...notification_list, resp]));
      } else {
        dispatch(notification_success([resp]));
      }
      // if (Acct_profile?._id == resp?.officialId) {
      //   dispatch(getNotification());
      // }
    });
    return () => {
      socket.off("jobNotification");
    };
  }, [socket]);

  // console.log("notification", notification);
  useEffect(() => {
    if (socket === null) {
      const newSocket = io(baseURL, {
        path: "/chat",
        withCredentials: true,
        cors: {
          origin: [employerUrl, baseURL1], // "http://localhost:3000", 'http://localhost:3001'
        },
      });
      // socketClient.connect();
      // setSocket(newSocket);
      dispatch(socketio(newSocket));
    }
    // if (window.location.pathname.includes("inbox") && index !== null) {
    socket?.on("getMessage", (resp) => {
      // console.log("getmessage", resp);
      dispatch(end_to_end_chat(resp?.message));
      // console.log("chat_info", chat_info);
      if (chat_info !== null) {
        if (chat_info[index]?._id !== resp?.chatId) {
          return;
        }
      }

      if (resp !== null) {
        // setNewMsg(resp?.message);
        // console.log("newMessage", newMessage);
      }
    });
    // }
    // console.log("info", chat_info);
    socket?.on("notification", (resp) => {
      // setNotification(prev => [resp, ...prev]);
      // console.log("information 1", chat_info);
      let msg_notification = 0;
      if (chat_info !== null) {
        chat_info.forEach((element) => {
          let acctType_profile_id =
            profile_stat.profile_status.AcctType == "Client"
              ? element?.chatIds[0]?.employerId?._id
              : element?.chatIds[0]?.employeeId?._id;
          // if (element._id === chat_info[index]?._id) {
          //   return;
          // } else {
          if (acctType_profile_id == resp.senderId) {
            // console.log("notify notification")
            element.Notification += 1;
          }
          // }
        });

        // loop tru resp.data to get the number of message notifications
        for (let i = 0; i <= chat_info.length - 1; i++) {
          if (chat_info[i].Notification > 0) {
            msg_notification += 1;
          }
        }
        dispatch(message_notification(msg_notification));
      }
    });

    return () => {
      socket?.off("notification");
    };
  }, [socket]);

  useEffect(() => {
    if (socket === null) return;

    socket.on("getInterestnotification", (resp) => {
      // console.log("getInterestnotification", resp);
      if (resp !== null) {
        let data = [...notification_list, resp];
        dispatch(notification_success(data));
      }
    });
  }, [socket]);

  useEffect(() => {
    if (socket === null) return;

    socket.on("decisionCardNotification", (resp) => {
      // console.log("decisionCardNotification", resp);
      if (resp !== null) {
        let data = [...notification_list, resp];
        dispatch(notification_success(data));
      }
    });
  }, [socket]);

  useEffect(() => {
    if (chat_info !== null) {
      let msg_notification = 0;
      // loop tru resp.data to get the number of message notifications
      for (let i = 0; i <= chat_info.length - 1; i++) {
        if (chat_info[i].Notification > 0) {
          msg_notification += 1;
        }
      }
      dispatch(message_notification(msg_notification)); // dispatch the overall notification.
    }
  }, [chat_info]);

  const handleNoProfile = () => {
    setTimeout(() => {
      toast.error(
        "You don't have a profile yet. Kindly generate a resume to create your profile",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }, 50);
  };

  const handleNoMessage = () => {
    setTimeout(() => {
      toast.error(
        "You don't have any message yet. Kindly generate a resume to create your profile",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }, 50);
  };

  const handleNoJob = () => {
    setTimeout(() => {
      toast.error("You don't have any job yet. Kindly generate a resume ", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }, 50);
  };

  const activeClassName = ({ isActive }) => {
    return isActive
      ? `text-xs max-[1024px]:rounded-lg w-max xl:w-[101%] rounded-tl-[56px] rounded-bl-[56px] fill-[#7066A3] px-1 py-2  bg-[#FAFAFA] py-2 flex flex-col max-[1024px]:justify-center items-center gap-1 hover:text-[#7066A3] text-[#7066A3] mx-auto`
      : `text-[#898989] hover:text-white text-xs fill-[#fff] rounded-[56px] flex-col px-1 py-4 text-white flex max-[1024px]:justify-center items-center gap-1 max-[1024px]:mx-auto`;
  };

  return (
    <>
      <MoreMenu
        isOpen={isMoreMenuOpen}
        onClose={() => setIsMoreMenuOpen(false)}
        EmployeeProfile={EmployeeProfile}
        handleNoMessage={handleNoMessage}
        handleNoProfile={handleNoProfile}
        activeClassName={activeClassName}
        msg_notification={msg_notification}
        dispatch={dispatch}
        message_notification={message_notification}
      />

      <div className={`py-3 px-4 md:hidden sidebar-gradient`}>
        <nav className="h-[54px]">
          <ul className="flex justify-between">
            <li>
              <NavLink
                to={
                  EmployeeProfile.message !== null
                    ? "/user/dashboard"
                    : "/user/welcome"
                }
                className={activeClassName}
              >
                <svg
                  width="18"
                  className="text-white fill-inherit"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.03464 0.666016L3.4513 0.666016C1.6263 0.666016 0.667969 1.62435 0.667969 3.44102L0.667969 5.02435C0.667969 6.84102 1.6263 7.79935 3.44297 7.79935H5.0263C6.84297 7.79935 7.8013 6.84102 7.8013 5.02435V3.44102C7.80964 1.62435 6.8513 0.666016 5.03464 0.666016Z"
                    fill="fill-inherit"
                  />
                  <path
                    d="M14.5576 0.666016L12.9742 0.666016C11.1576 0.666016 10.1992 1.62435 10.1992 3.44102V5.02435C10.1992 6.84102 11.1576 7.79935 12.9742 7.79935H14.5576C16.3742 7.79935 17.3326 6.84102 17.3326 5.02435V3.44102C17.3326 1.62435 16.3742 0.666016 14.5576 0.666016Z"
                    fill="fill-inherit"
                  />
                  <path
                    d="M14.5576 10.1914H12.9742C11.1576 10.1914 10.1992 11.1497 10.1992 12.9664V14.5497C10.1992 16.3664 11.1576 17.3247 12.9742 17.3247H14.5576C16.3742 17.3247 17.3326 16.3664 17.3326 14.5497V12.9664C17.3326 11.1497 16.3742 10.1914 14.5576 10.1914Z"
                    fill="fill-inherit"
                  />
                  <path
                    d="M5.03464 10.1914H3.4513C1.6263 10.1914 0.667969 11.1497 0.667969 12.9664L0.667969 14.5497C0.667969 16.3747 1.6263 17.3331 3.44297 17.3331H5.0263C6.84297 17.3331 7.8013 16.3747 7.8013 14.5581V12.9747C7.80964 11.1497 6.8513 10.1914 5.03464 10.1914Z"
                    fill="fill-inherit"
                  />
                </svg>
                <span className="">Dashboard</span>
              </NavLink>
            </li>
            <li>
              {EmployeeProfile.message !== null ? (
                <NavLink to={"/resume"} className={activeClassName}>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.19922 0C1.99008 0 0.199219 1.79086 0.199219 4V16C0.199219 18.2091 1.99008 20 4.19922 20H16.1992C18.4084 20 20.1992 18.2091 20.1992 16V4C20.1992 1.79086 18.4084 0 16.1992 0H4.19922ZM16.7488 12.8818C16.8957 12.7349 16.9782 12.5358 16.9782 12.3281C16.9782 12.1216 16.8961 11.9235 16.7501 11.7774C16.6041 11.6314 16.406 11.5494 16.1995 11.5494H10.2639C10.0669 11.564 9.88263 11.6527 9.74819 11.7975C9.61375 11.9423 9.53904 12.1326 9.53904 12.3302C9.53904 12.5279 9.61375 12.7182 9.74819 12.863C9.88263 13.0078 10.0669 13.0964 10.2639 13.1111H16.1951C16.4028 13.1111 16.602 13.0286 16.7488 12.8818ZM10.2596 14.5171H13.461C13.658 14.5318 13.8423 14.6205 13.9767 14.7653C14.1111 14.9101 14.1859 15.1004 14.1859 15.298C14.1859 15.4956 14.1111 15.6859 13.9767 15.8307C13.8423 15.9756 13.658 16.0642 13.461 16.0789H10.2596C10.0625 16.0642 9.8783 15.9756 9.74386 15.8307C9.60942 15.6859 9.53471 15.4956 9.53471 15.298C9.53471 15.1004 9.60942 14.9101 9.74386 14.7653C9.8783 14.6205 10.0625 14.5318 10.2596 14.5171ZM16.7531 8.79797C16.6063 8.65112 16.4071 8.56862 16.1995 8.56862H10.2639C10.0562 8.56862 9.85707 8.65112 9.71022 8.79797C9.56337 8.94481 9.48087 9.14398 9.48087 9.35166C9.48087 9.55934 9.56337 9.75851 9.71022 9.90535C9.85707 10.0522 10.0562 10.1347 10.2639 10.1347H16.1995C16.4071 10.1347 16.6063 10.0522 16.7531 9.90535C16.9 9.75851 16.9825 9.55934 16.9825 9.35166C16.9825 9.14398 16.9 8.94481 16.7531 8.79797ZM7.67097 10.6591C7.8158 10.5246 7.90444 10.3404 7.91912 10.1434C7.91912 9.52147 7.67208 8.92507 7.23234 8.48533C6.79261 8.0456 6.1962 7.79856 5.57432 7.79856C4.95244 7.79856 4.35603 8.0456 3.9163 8.48533C3.47656 8.92507 3.22952 9.52147 3.22952 10.1434V15.2959C3.22952 15.5035 3.31202 15.7027 3.45887 15.8495C3.60572 15.9964 3.80489 16.0789 4.01256 16.0789C4.22024 16.0789 4.41941 15.9964 4.56626 15.8495C4.71311 15.7027 4.7956 15.5035 4.7956 15.2959V13.5005H5.57432C5.77138 13.4858 5.95561 13.3972 6.09005 13.2523C6.22449 13.1075 6.2992 12.9172 6.2992 12.7196C6.2992 12.522 6.22449 12.3317 6.09005 12.1869C5.95561 12.042 5.77138 11.9534 5.57432 11.9387H4.7956V10.1434C4.81028 9.94629 4.89892 9.76207 5.04375 9.62763C5.18857 9.49319 5.37888 9.41848 5.57648 9.41848C5.77409 9.41848 5.96439 9.49319 6.10922 9.62763C6.25404 9.76207 6.34268 9.94629 6.35736 10.1434C6.37204 10.3404 6.46068 10.5246 6.60551 10.6591C6.75033 10.7935 6.94063 10.8682 7.13824 10.8682C7.33585 10.8682 7.52615 10.7935 7.67097 10.6591ZM16.7152 4.49057C16.5807 4.34574 16.3965 4.2571 16.1995 4.24242H3.99958C3.80252 4.2571 3.6183 4.34574 3.48386 4.49057C3.34942 4.63539 3.27471 4.8257 3.27471 5.0233C3.27471 5.22091 3.34942 5.41121 3.48386 5.55604C3.6183 5.70086 3.80252 5.7895 3.99958 5.80418H16.1995C16.3965 5.7895 16.5807 5.70086 16.7152 5.55604C16.8496 5.41121 16.9243 5.22091 16.9243 5.0233C16.9243 4.8257 16.8496 4.63539 16.7152 4.49057Z"
                      fill="#9C88FF"
                    />
                  </svg>

                  <span className=""> My Resumes</span>
                </NavLink>
              ) : (
                <div
                  onClick={() => handleNoResume()}
                  className={`text-[#898989] hover:text-white text-xs fill-[#fff] rounded-[56px] flex-col px-1 py-4 text-white flex max-[1024px]:justify-center items-center gap-1 max-[1024px]:mx-auto`}
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    className="fill-inherit"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.19922 0C1.99008 0 0.199219 1.79086 0.199219 4V16C0.199219 18.2091 1.99008 20 4.19922 20H16.1992C18.4084 20 20.1992 18.2091 20.1992 16V4C20.1992 1.79086 18.4084 0 16.1992 0H4.19922ZM16.7488 12.8818C16.8957 12.7349 16.9782 12.5358 16.9782 12.3281C16.9782 12.1216 16.8961 11.9235 16.7501 11.7774C16.6041 11.6314 16.406 11.5494 16.1995 11.5494H10.2639C10.0669 11.564 9.88263 11.6527 9.74819 11.7975C9.61375 11.9423 9.53904 12.1326 9.53904 12.3302C9.53904 12.5279 9.61375 12.7182 9.74819 12.863C9.88263 13.0078 10.0669 13.0964 10.2639 13.1111H16.1951C16.4028 13.1111 16.602 13.0286 16.7488 12.8818ZM10.2596 14.5171H13.461C13.658 14.5318 13.8423 14.6205 13.9767 14.7653C14.1111 14.9101 14.1859 15.1004 14.1859 15.298C14.1859 15.4956 14.1111 15.6859 13.9767 15.8307C13.8423 15.9756 13.658 16.0642 13.461 16.0789H10.2596C10.0625 16.0642 9.8783 15.9756 9.74386 15.8307C9.60942 15.6859 9.53471 15.4956 9.53471 15.298C9.53471 15.1004 9.60942 14.9101 9.74386 14.7653C9.8783 14.6205 10.0625 14.5318 10.2596 14.5171ZM16.7531 8.79797C16.6063 8.65112 16.4071 8.56862 16.1995 8.56862H10.2639C10.0562 8.56862 9.85707 8.65112 9.71022 8.79797C9.56337 8.94481 9.48087 9.14398 9.48087 9.35166C9.48087 9.55934 9.56337 9.75851 9.71022 9.90535C9.85707 10.0522 10.0562 10.1347 10.2639 10.1347H16.1995C16.4071 10.1347 16.6063 10.0522 16.7531 9.90535C16.9 9.75851 16.9825 9.55934 16.9825 9.35166C16.9825 9.14398 16.9 8.94481 16.7531 8.79797ZM7.67097 10.6591C7.8158 10.5246 7.90444 10.3404 7.91912 10.1434C7.91912 9.52147 7.67208 8.92507 7.23234 8.48533C6.79261 8.0456 6.1962 7.79856 5.57432 7.79856C4.95244 7.79856 4.35603 8.0456 3.9163 8.48533C3.47656 8.92507 3.22952 9.52147 3.22952 10.1434V15.2959C3.22952 15.5035 3.31202 15.7027 3.45887 15.8495C3.60572 15.9964 3.80489 16.0789 4.01256 16.0789C4.22024 16.0789 4.41941 15.9964 4.56626 15.8495C4.71311 15.7027 4.7956 15.5035 4.7956 15.2959V13.5005H5.57432C5.77138 13.4858 5.95561 13.3972 6.09005 13.2523C6.22449 13.1075 6.2992 12.9172 6.2992 12.7196C6.2992 12.522 6.22449 12.3317 6.09005 12.1869C5.95561 12.042 5.77138 11.9534 5.57432 11.9387H4.7956V10.1434C4.81028 9.94629 4.89892 9.76207 5.04375 9.62763C5.18857 9.49319 5.37888 9.41848 5.57648 9.41848C5.77409 9.41848 5.96439 9.49319 6.10922 9.62763C6.25404 9.76207 6.34268 9.94629 6.35736 10.1434C6.37204 10.3404 6.46068 10.5246 6.60551 10.6591C6.75033 10.7935 6.94063 10.8682 7.13824 10.8682C7.33585 10.8682 7.52615 10.7935 7.67097 10.6591ZM16.7152 4.49057C16.5807 4.34574 16.3965 4.2571 16.1995 4.24242H3.99958C3.80252 4.2571 3.6183 4.34574 3.48386 4.49057C3.34942 4.63539 3.27471 4.8257 3.27471 5.0233C3.27471 5.22091 3.34942 5.41121 3.48386 5.55604C3.6183 5.70086 3.80252 5.7895 3.99958 5.80418H16.1995C16.3965 5.7895 16.5807 5.70086 16.7152 5.55604C16.8496 5.41121 16.9243 5.22091 16.9243 5.0233C16.9243 4.8257 16.8496 4.63539 16.7152 4.49057Z"
                      fill="fill-inherit"
                    />
                  </svg>

                  <span className=""> Resumes</span>
                </div>
              )}
            </li>
            <li>
              {EmployeeProfile.message === null ? (
                <div
                  className={`text-[#898989] hover:text-white text-xs fill-[#fff] rounded-[56px] flex-col px-1 py-4 text-white flex max-[1024px]:justify-center items-center gap-1 max-[1024px]:mx-auto`}
                  onClick={handleNoJob}
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    className="fill-inherit"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.3708 5.81628C17.6624 5.03294 16.4791 4.64128 14.7624 4.64128H14.5624V4.60794C14.5624 3.20794 14.5624 1.47461 11.4291 1.47461L10.1624 1.47461C7.0291 1.47461 7.0291 3.21628 7.0291 4.60794V4.64961H6.8291C5.1041 4.64961 3.9291 5.04128 3.22077 5.82461C2.39577 6.74128 2.42077 7.97461 2.5041 8.81628L2.51243 8.87461L2.57389 9.51987C2.58773 9.66523 2.66605 9.79657 2.78831 9.8764C2.99019 10.0082 3.30416 10.2098 3.49577 10.3163C3.61243 10.3913 3.73743 10.4579 3.86243 10.5246C5.28743 11.3079 6.8541 11.8329 8.44577 12.0913C8.52077 12.8746 8.86243 13.7913 10.6874 13.7913C12.5124 13.7913 12.8708 12.8829 12.9291 12.0746C14.6291 11.7996 16.2708 11.2079 17.7541 10.3413C17.8041 10.3163 17.8374 10.2913 17.8791 10.2663C18.2011 10.0843 18.5349 9.86107 18.841 9.64118C18.9508 9.56226 19.0209 9.43985 19.0359 9.30543L19.0458 9.21628L19.0874 8.82461C19.0958 8.77461 19.0958 8.73294 19.1041 8.67461C19.1708 7.83294 19.1541 6.68294 18.3708 5.81628ZM11.7041 11.5246C11.7041 12.4079 11.7041 12.5413 10.6791 12.5413C9.6541 12.5413 9.6541 12.3829 9.6541 11.5329V10.4829H11.7041L11.7041 11.5246ZM8.22077 4.64128V4.60794C8.22077 3.19128 8.22077 2.66628 10.1624 2.66628H11.4291C13.3708 2.66628 13.3708 3.19961 13.3708 4.60794V4.64961L8.22077 4.64961V4.64128Z"
                      fill="fill-inherit"
                    />
                    <path
                      d="M18.0764 11.4975C18.4199 11.3349 18.8145 11.6074 18.7802 11.9859L18.4922 15.1583C18.3172 16.8249 17.6339 18.5249 13.9672 18.5249H7.61719C3.95052 18.5249 3.26719 16.8249 3.09219 15.1666L2.81914 12.163C2.78513 11.789 3.17147 11.5171 3.51402 11.6712C4.47258 12.1025 6.10863 12.8076 7.15288 13.0875C7.3121 13.1302 7.44123 13.2446 7.51302 13.393C8.02576 14.453 9.11635 15.0166 10.6839 15.0166C12.2359 15.0166 13.3399 14.4312 13.8545 13.3682C13.9264 13.2197 14.0555 13.1054 14.2148 13.0624C15.3252 12.7631 17.0715 11.973 18.0764 11.4975Z"
                      fill="fill-inherit"
                    />
                  </svg>

                  <span className=""> Jobs</span>
                </div>
              ) : (
                <NavLink
                  to={"/user/jobs"}
                  className={activeClassName}
                  onClick={() => dispatch(message_notification(0))}
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    className="fill-inherit"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.3708 5.81628C17.6624 5.03294 16.4791 4.64128 14.7624 4.64128H14.5624V4.60794C14.5624 3.20794 14.5624 1.47461 11.4291 1.47461L10.1624 1.47461C7.0291 1.47461 7.0291 3.21628 7.0291 4.60794V4.64961H6.8291C5.1041 4.64961 3.9291 5.04128 3.22077 5.82461C2.39577 6.74128 2.42077 7.97461 2.5041 8.81628L2.51243 8.87461L2.57389 9.51987C2.58773 9.66523 2.66605 9.79657 2.78831 9.8764C2.99019 10.0082 3.30416 10.2098 3.49577 10.3163C3.61243 10.3913 3.73743 10.4579 3.86243 10.5246C5.28743 11.3079 6.8541 11.8329 8.44577 12.0913C8.52077 12.8746 8.86243 13.7913 10.6874 13.7913C12.5124 13.7913 12.8708 12.8829 12.9291 12.0746C14.6291 11.7996 16.2708 11.2079 17.7541 10.3413C17.8041 10.3163 17.8374 10.2913 17.8791 10.2663C18.2011 10.0843 18.5349 9.86107 18.841 9.64118C18.9508 9.56226 19.0209 9.43985 19.0359 9.30543L19.0458 9.21628L19.0874 8.82461C19.0958 8.77461 19.0958 8.73294 19.1041 8.67461C19.1708 7.83294 19.1541 6.68294 18.3708 5.81628ZM11.7041 11.5246C11.7041 12.4079 11.7041 12.5413 10.6791 12.5413C9.6541 12.5413 9.6541 12.3829 9.6541 11.5329V10.4829H11.7041L11.7041 11.5246ZM8.22077 4.64128V4.60794C8.22077 3.19128 8.22077 2.66628 10.1624 2.66628H11.4291C13.3708 2.66628 13.3708 3.19961 13.3708 4.60794V4.64961L8.22077 4.64961V4.64128Z"
                      fill="#9C88FF"
                    />
                    <path
                      d="M18.0764 11.4975C18.4199 11.3349 18.8145 11.6074 18.7802 11.9859L18.4922 15.1583C18.3172 16.8249 17.6339 18.5249 13.9672 18.5249H7.61719C3.95052 18.5249 3.26719 16.8249 3.09219 15.1666L2.81914 12.163C2.78513 11.789 3.17147 11.5171 3.51402 11.6712C4.47258 12.1025 6.10863 12.8076 7.15288 13.0875C7.3121 13.1302 7.44123 13.2446 7.51302 13.393C8.02576 14.453 9.11635 15.0166 10.6839 15.0166C12.2359 15.0166 13.3399 14.4312 13.8545 13.3682C13.9264 13.2197 14.0555 13.1054 14.2148 13.0624C15.3252 12.7631 17.0715 11.973 18.0764 11.4975Z"
                      fill="#9C88FF"
                    />
                  </svg>

                  <span className="">My Jobs</span>
                </NavLink>
              )}
            </li>

            <li>
              <button
                onClick={() => setIsMoreMenuOpen(true)}
                className={`text-[#898989] hover:text-white text-xs fill-[#fff] rounded-[56px] flex-col px-1 py-4 text-white flex max-[1024px]:justify-center items-center gap-1 max-[1024px]:mx-auto relative`}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="10" cy="4" r="1.5" fill="currentColor" />
                  <circle cx="10" cy="10" r="1.5" fill="currentColor" />
                  <circle cx="10" cy="16" r="1.5" fill="currentColor" />
                </svg>
                <span className="">More</span>
                {msg_notification > 0 && (
                  <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
                )}
              </button>
            </li>
          </ul>
        </nav>
        <ToastContainer />
      </div>
    </>
  );
};

export default BottonBar;
